export const productPrevent = {
  data() {
    return {
      disableNavigation: false,
      productCopy: null
    }
  },
  beforeRouteLeave(to, from, next) {
    if(this.disableNavigation) {
      this.swalUnsavedChanges().then(result => {
        if(result.value) {
          this.product = this.productCopy;
          next();
        }
      });
    } else {
      next();
    }
  },
  created() {
    this.productCopy = JSON.parse(JSON.stringify(this.product))
  },
  watch: {
    product: {
      handler(value) {
        this.disableNavigation = JSON.stringify(value) !== JSON.stringify(this.productCopy)
      },
      deep: true
    }
  }
};
